export interface IPrimary_Branch {
    id?: string;
    updated_at?: Date;
    created_at?: Date;
    is_active?: boolean;
    address?: string;
    pincode?: string;
    created_by?: string;
    updated_by?: string;
    city?: any;
    state?: any;
    unit_name?: any;
    company?: string;
}

export class Primary_Branch {
    id?: string;
    updated_at?: Date;
    created_at?: Date;
    is_active?: boolean;
    address?: string;
    pincode?: string;
    created_by?: string;
    updated_by?: string;
    city?: any;
    state?: any;
    unit_name?: any;
    company?: string;

    constructor() {
        this.id = null;
        this.is_active = true;
        this.address = null;
        this.pincode = null;
        this.city = null;
        this.state = null;
        this.updated_at = null;
        this.created_at = null;
        this.created_by = null;
        this.updated_by = null;
        this.unit_name = null;
        this.company = null;
    }
}